import { render, staticRenderFns } from "./AlertOccurrence.vue?vue&type=template&id=610e58f8&scoped=true"
import script from "./AlertOccurrence.vue?vue&type=script&lang=js"
export * from "./AlertOccurrence.vue?vue&type=script&lang=js"
import style0 from "./AlertOccurrence.vue?vue&type=style&index=0&id=610e58f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e58f8",
  null
  
)

export default component.exports